import { render, staticRenderFns } from "./UserInfoPublishSetting.vue?vue&type=template&id=7599cd05&scoped=true&"
import script from "./UserInfoPublishSetting.vue?vue&type=script&lang=ts&"
export * from "./UserInfoPublishSetting.vue?vue&type=script&lang=ts&"
import style0 from "./UserInfoPublishSetting.vue?vue&type=style&index=0&id=7599cd05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7599cd05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow})
